export function pesanReducer(state = {
    data: null,
    links: null,
    isPending: true,
  }, action){
    switch(action.type){
      case 'PESAN_RESET':
        return Object.assign({}, state, {
          data: null,
          links: null,
          isPending: true,
        })
        
      case 'GET_PESAN_FULFILLED':
        return Object.assign({}, state, {
            data:  action.payload.data.results.meta.current_page === 1 ?
                    action.payload.data.results.data : 
                    state.data.concat(action.payload.data.results.data),
            links: action.payload.data.results.links,
            isPending: false,
        })
    
      case 'GET_PESAN_PENDING':
          return Object.assign({}, state, {
              // data: state.data,
              isPending: true,
          })
          
      default:
        return state
    }
  }


  export function createPesan(state = {
    isPending: false,
    isSuccess: false,
  }, action){
    switch(action.type){
      case 'CREATE_PESAN_PENDING':
        return Object.assign({}, state, {
          isPending: true,
          isSuccess: false,
        })
      
        case 'CREATE_PESAN_FULFILLED':
        return Object.assign({}, state, {
          isPending: false,
          isSuccess: true,
        })
        
      default:
        return state
    }
  }

export function getPesanDetail(state = {
  data: null,
  id: null,
  status: null,
  subject: null,
  isPending: true,
  isSuccess: false,
}, action){
  switch(action.type){
    case 'GET_PESAN_DETAIL_PENDING':
      return Object.assign({}, state, {
        isPending: true,
        isSuccess: false,
        data: null,
      })
    
      case 'GET_PESAN_DETAIL_FULFILLED':
        return Object.assign({}, state, {
          data: action.payload.data.results.data,
          id: action.payload.data.results.id,
          status: action.payload.data.results.status,
          subject: action.payload.data.results.subject,
          isPending: false,
          isSuccess: true,
        })
      
    default:
      return state
  }
}

export function detailReply(state = {
  isPending: false,
  isSuccess: false,
}, action){
  switch(action.type){
    case 'PESAN_REPLY_PENDING':
      return Object.assign({}, state, {
        isPending: true,
        isSuccess: false,
      })
    
      case 'PESAN_REPLY_FULFILLED':
      return Object.assign({}, state, {
        isPending: false,
        isSuccess: true,
      })
      
    default:
      return state
  }
}

